<template>
  <CreateEditMerchantForm
    :merchant-id="parseInt(merchantId)"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  merchantId: string
}>()
</script>
